module.exports = __webpack_public_path__ + "img/cloth_g3_item-09.663ae985.svg";